import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import AppShell from "@/components/AppShell";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { formatDistanceToNow } from "date-fns";
import NotificationCard from "@/components/business/NotificationCard";
import PageHeader from "@/components/business/PageHeader";

export default function Notifications() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/notifications").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);

  const markAll = async () => { await api.post("/notifications/read-all"); load(); };

  return (
    <AppShell>
      <div className="max-w-3xl mx-auto">
        <PageHeader>
          <PageHeader.Title>Notifications</PageHeader.Title>
          <PageHeader.Actions>
            <Button variant="outline" onClick={markAll} data-testid="mark-all-read">Mark all read</Button>
          </PageHeader.Actions>
        </PageHeader>

        <Card className="mt-6 border-border divide-y divide-border">
          {items.length === 0 && <div className="p-10 text-center text-sm text-muted-foreground">You're all caught up.</div>}
          {items.map((n) => (
            <NotificationCard
              key={n.id}
              showKindIcon
              notification={n}
              formattedTime={formatDistanceToNow(new Date(n.created_at), { addSuffix: true })}
            />
          ))}
        </Card>
      </div>
    </AppShell>
  );
}
